import React, { useContext } from "react";
import { IGeneralTermsContext } from "../../types/generalTerms";
import { GeneralTermsContext } from "../../context/generalTermsContext";
import ModalPdfGeneralTerms from "../modalPdfGeneralTerms/ModalPdfGeneralTerms";
import ApplicationFallback from "../applicationFallback/ApplicationFallback";
import { generalTermsService } from "../../api/generalTermsService/generalTermsService";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

type Props = {
    children: React.ReactElement<any, any>
}

const GeneralTermsVerifier: React.FC<Props> = ({
    children
}) => {
    const { t } = useTranslation();

    const {
        hasAcceptedDriversRules,
        hasAcceptedGeneralTerms,        
        loading,
        setLoading,
        driversRulesDocument,
        generalTermsDocument,
        driversRulesDescription,
        generalTermsDescription,
    } = useContext(GeneralTermsContext) as IGeneralTermsContext;

    const acceptGeneralTerms = async () => {
        setLoading(true);
        const response = await generalTermsService.acceptTerms({
            generalTerms: true,
            duvri: hasAcceptedDriversRules
        });

        if (response.success) {
            window.location.reload();
        } else {
            toast.error(t('errors.errorAcceptanceGeneralTerms'))
        }

        setLoading(false);
    }

    const acceptDriversRules = async () => {
        setLoading(true);
        const response = await generalTermsService.acceptTerms({
            generalTerms: hasAcceptedGeneralTerms,
            duvri: true
        });

        if (response.success) {
            // setHasAcceptedDriversRules(true);
            window.location.reload();
        } else {
            toast.error(t('errors.errorAcceptanceGeneralTerms'))
        }

        setLoading(false);
    }

    return (
        <>
            {
                hasAcceptedDriversRules && hasAcceptedGeneralTerms &&
                <>
                    {children}
                </>
            }

            {
                (!hasAcceptedDriversRules || !hasAcceptedGeneralTerms) &&
                <>
                    {
                        !loading &&
                        <>
                            {
                                !hasAcceptedGeneralTerms ?
                                    <ModalPdfGeneralTerms
                                        name={t('components.modalGeneralTerms.nameGeneralTerms')}
                                        callbackOnAccept={acceptGeneralTerms}
                                        descriptionTooltip={generalTermsDescription}
                                        pdfBase64={generalTermsDocument}
                                        titleTooltip={t('components.modalGeneralTerms.nameGeneralTerms')}
                                    />
                                    :
                                    <ModalPdfGeneralTerms
                                        name={t('components.modalGeneralTerms.nameDriversRules')}
                                        callbackOnAccept={acceptDriversRules}
                                        descriptionTooltip={driversRulesDescription}
                                        pdfBase64={driversRulesDocument}
                                        titleTooltip={t('components.modalGeneralTerms.nameDriversRules')}
                                    />
                            }
                        </>
                    }

                    {
                        loading &&
                        <ApplicationFallback />
                    }
                </>
            }
        </>
    );
}

export default GeneralTermsVerifier;